import script from "./CloseButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CloseButton.vue?vue&type=script&setup=true&lang=js"

import "./CloseButton.vue?vue&type=style&index=0&id=e6cfc302&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6cfc302"]])

export default __exports__